module.exports = __webpack_public_path__ + "8f5882080652f5b0159b3c2198d855f5.png";